import script from "./accountSnSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./accountSnSetting.vue?vue&type=script&setup=true&lang=ts"

import "./accountSnSetting.vue?vue&type=style&index=0&id=792890b6&scoped=true&lang=less"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-792890b6"]])

export default __exports__